import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import AuthSlx         from 'app/selectors/auth';
import EllipsisMenu    from 'app/components/common/ellipsis-menu';
import Icon            from 'app/components/common/icon';
import RteViewer       from 'app/components/common/rich-text/viewer';
import CommentForm     from 'app/components/company-admin/grant-system/comment-form';
import FileChips       from 'app/components/company-admin/grant-system/file-chips';
import {
  EmployeeRoles,
}                      from 'app/constants';
import GrantsSysDuck   from 'app/ducks/company-admin/grant-system';
import cdn             from 'app/helpers/cdn';
import prompts         from 'app/prompts';



class Comment extends React.PureComponent {

  constructor(props) {
    super(props);

    this.state = {
      deletePending: false,
      editMode: false,
    };

    this.onClickDelete = this.onClickDelete.bind(this);
    this.onClickEdit = this.onClickEdit.bind(this);
    this.onClickEditCancel = this.onClickEditCancel.bind(this);
    this.onEditSubmit = this.onEditSubmit.bind(this);
  }

  get isAuthor() {
    if (!this.props.emp || !this.props.comment) return false;
    return this.props.emp.id === this.props.comment.employeeId;    
  }
  get canEdit() {
    return this.isAuthor;
  }
  get canDelete() {
    if (this.isAuthor) return true;
    if (this.props.emp?.role === EmployeeRoles.ADMIN) return true;
    if (this.props.isBsSuper) return true;
    // TODO: check emp<>program permissions
    return false;
  }
  async onClickDelete(event) {
    event.preventDefault();
    const msg = 'Are you sure you want to delete this comment?\nThis can not be undone.';
    const didConfirm = await prompts.confirm({msg, danger: 'Delete Comment'});
    if (didConfirm) {
      this.setState({deletePending: true});
      await this.props.delete();
    }
  }

  onClickEdit(event) {
    event.preventDefault();
    setTimeout(() => {
      this.setState({editMode: true});
    }, 0);
  }
  onClickEditCancel() {
    setTimeout(() => {
      this.setState({editMode: false});
    }, 0);
  }
  async onEditSubmit(attrs) {
    await this.props.update(attrs);
    this.setState({editMode: false});
  }

  renderEdit() {
    const {comment} = this.props;
    return (
      <CommentForm
        onSubmit={this.onEditSubmit}
        onCancel={this.onClickEditCancel}
        initialBody={comment.body}
        initialFiles={comment.files}
        allowFiles={!comment.formAnswerId}
        submitLabel="Update"
        submitPendingLabel="Updating..."
        focusOnMount
      />
    );
  }

  render() {
    const {comment, appId, className} = this.props;
    const {editMode} = this.state;
    const showMenu = (this.canEdit || this.canDelete) && !editMode;
    const editClass = editMode ? 'edit' : '';

    return (
      <div className={`gacom ${editClass} ${className}`}>
        <div className="gacom-body-con">
          {editMode
            ? this.renderEdit()
            : (<>
              {!!comment.body && <RteViewer md={comment.body} className="gacom-body" />}
              {!!comment.files?.length && (
                <FileChips files={comment.files} className="gacom-files" />
              )}
            </>)
          }
        </div>
        {showMenu && (
          <EllipsisMenu className="gacom-em alt1" usePortal>
            {this.canEdit   && <a href="#" onClick={this.onClickEdit}><Icon.Pencil /> Edit</a>}
            {this.canDelete && <a href="#" onClick={this.onClickDelete}><Icon.Bin /> Delete</a>}
          </EllipsisMenu>
        )}
      </div>
    );
  }

}

Comment.propTypes = {
  comment: PropTypes.object.isRequired,
  appId: PropTypes.string.isRequired,
  className: PropTypes.string,
};

Comment.defaultProps = {
  className: '',
};

const stateToProps = (state) => ({
  // currentUser: AuthSlx.currentUser(state),
  isBsSuper: AuthSlx.isBsSuper(state),
  emp: AuthSlx.currentEmp(state),
});
const dispatchToProps = (dispatch, ownProps) => ({
  update: (attrs) => dispatch(GrantsSysDuck.Ax.commentsUpdate(ownProps.appId, ownProps.comment.id, attrs)),
  delete: (attrs) => dispatch(GrantsSysDuck.Ax.commentsDelete(ownProps.appId, ownProps.comment.id)),
});

export default connect(stateToProps, dispatchToProps)(Comment);
